import React from "react";
import MyProperties from "../../components/MyProperties";

export default function OwnerDashboard() {
  return (
    <div data-testid="owner-dashboard">
      <MyProperties />
    </div>
  );
}
